module.exports = __webpack_public_path__ + "src/assets/img/1.caf2b92d.jpg";